export class SgBranding {
    private signature_color: string;
    private application_layout_color: string;
    private application_text_color: string;
    private header_color: string;
    private footer_color: string;
    private logo: string;
    private logoSidebar: string;

    get signatureColor(): string {
        return this.signature_color;
    }

    set signatureColor(value: string) {
        this.signature_color = value;
    }

    get applicationLayoutColor(): string {
        return this.application_layout_color;
    }

    set applicationLayoutColor(value: string) {
        this.application_layout_color = value;
    }

    get applicationTextColor(): string {
        return this.application_text_color;
    }

    set applicationTextColor(value: string) {
        this.application_text_color = value;
    }

    get headerColor(): string {
        return this.header_color;
    }

    set headerColor(value: string) {
        this.header_color = value;
    }

    get footerColor(): string {
        return this.footer_color;
    }

    set footerColor(value: string) {
        this.footer_color = value;
    }

    get currentLogo(): string {
        return this.logo;
    }

    set currentLogo(value: string) {
        this.logo = value;
    }

    get currentLogoSidebar(): string {
        return this.logoSidebar;
    }

    set currentLogoSidebar(value: string) {
        this.logoSidebar = value;
    }
}
